// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Model
export class PublishedFeature {
    constructor(model) {
        this.featureName = model.featureName;
        this.iterationName = model.iterationName;
        this.thumbnailUrl = model.thumbnailUrl;
        this.staticPreviewUrl = model.staticPreviewUrl;
        this.hideSupernovaUI = model.hideSupernovaUI;
        this.projectId = model.projectId;
        this.projectName = model.projectName;
        this.workspaceId = model.workspaceId;
    }
    toRemote() {
        return {
            ...this,
        };
    }
}
